import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('ls_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('ls_cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('ls_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent" role="dialog" aria-label="Cookie consent" className="fixed bottom-0 left-0 right-0 z-[60] bg-white border-t border-[var(--ls-border)] shadow-lg px-6 py-4">
      <div className="ls-container flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-[var(--ls-text)] text-center sm:text-left">
          We use cookies to enhance your experience, analyze site traffic, and personalize content. By clicking "Accept", you consent to our use of cookies.{' '}
          <a href="https://legasecure.com/privacy-policy" className="text-[var(--ls-gold)] underline">Learn more</a>
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button data-testid="cookie-decline" onClick={decline} className="px-5 py-2 text-sm text-[var(--ls-text-light)] border border-[var(--ls-border)] rounded-lg hover:bg-[var(--ls-bg)] transition-colors">
            Decline
          </button>
          <button data-testid="cookie-accept" onClick={accept} className="px-5 py-2 text-sm bg-[var(--ls-gold)] text-white rounded-lg hover:bg-[var(--ls-gold-dark)] transition-colors font-medium">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
